"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * API Documentation
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TokenApiAxiosParamCreator = exports.DefaultApi = exports.DefaultApiFactory = exports.DefaultApiFp = exports.DefaultApiAxiosParamCreator = exports.AdminApi = exports.AdminApiFactory = exports.AdminApiFp = exports.AdminApiAxiosParamCreator = exports.VersionObjectEnum = exports.TokenProfileCreateRequestKindEnum = exports.TokenObjectEnum = exports.TaskStatusKind = exports.TaskMode = exports.TaskDefinitionInterviewCreateRequestTypeEnum = exports.TaskDefinitionInterviewTypeEnum = exports.TaskDefinitionInterviewObjectEnum = exports.TaskDefinitionFormCreateRequestTypeEnum = exports.TaskDefinitionFormTypeEnum = exports.TaskDefinitionFormObjectEnum = exports.TaskDefinitionAccountOnboardedCreateRequestTypeEnum = exports.TaskDefinitionAccountOnboardedTypeEnum = exports.TaskDefinitionAccountOnboardedObjectEnum = exports.RewardMode = exports.RewardObjectEnum = exports.PromotionList200ResponseObjectEnum = exports.PromotionObjectEnum = exports.ProfileObjectEnum = exports.ProductList200ResponseObjectEnum = exports.ProductFixedCreateRequestKindEnum = exports.ProductDynamicCreateRequestKindEnum = exports.PartnerList200ResponseObjectEnum = exports.PartnerObjectEnum = exports.OfferStatus = exports.OfferList200ResponseObjectEnum = exports.OfferObjectEnum = exports.FixedProductKindEnum = exports.FixedProductObjectEnum = exports.EligibilityStatus = exports.EligibilityRewardStatus = exports.EligibilityObjectEnum = exports.DynamicProductKindEnum = exports.DynamicProductObjectEnum = exports.ConditionGroupModeEnum = exports.ConditionOperatorEnum = exports.AdminVersionList200ResponseObjectEnum = exports.AdminOfferList200ResponseObjectEnum = exports.AdminOfferObjectEnum = exports.AdminContributorList200ResponseObjectEnum = exports.AdminContributorObjectEnum = void 0;
exports.TokenApi = exports.TokenApiFactory = exports.TokenApiFp = void 0;
const axios_1 = __importDefault(require("axios"));
// Some imports not used depending on template conditions
// @ts-ignore
const common_1 = require("./common");
// @ts-ignore
const base_1 = require("./base");
exports.AdminContributorObjectEnum = {
    Contributor: 'contributor',
};
exports.AdminContributorList200ResponseObjectEnum = {
    List: 'list',
};
exports.AdminOfferObjectEnum = {
    Offer: 'offer',
};
exports.AdminOfferList200ResponseObjectEnum = {
    List: 'list',
};
exports.AdminVersionList200ResponseObjectEnum = {
    List: 'list',
};
exports.ConditionOperatorEnum = {
    Eq: 'eq',
    Gte: 'gte',
    Gt: 'gt',
    Lte: 'lte',
    Lt: 'lt',
};
exports.ConditionGroupModeEnum = {
    All: 'all',
    Any: 'any',
};
exports.DynamicProductObjectEnum = {
    Product: 'product',
};
exports.DynamicProductKindEnum = {
    Dynamic: 'dynamic',
};
exports.EligibilityObjectEnum = {
    Eligibility: 'eligibility',
};
/**
 *
 * @export
 * @enum {string}
 */
exports.EligibilityRewardStatus = {
    Fulfilled: 'fulfilled',
    Unfulfilled: 'unfulfilled',
};
/**
 *
 * @export
 * @enum {string}
 */
exports.EligibilityStatus = {
    Eligible: 'eligible',
    Ineligible: 'ineligible',
};
exports.FixedProductObjectEnum = {
    Product: 'product',
};
exports.FixedProductKindEnum = {
    Fixed: 'fixed',
};
exports.OfferObjectEnum = {
    Offer: 'offer',
};
exports.OfferList200ResponseObjectEnum = {
    List: 'list',
};
/**
 *
 * @export
 * @enum {string}
 */
exports.OfferStatus = {
    Draft: 'draft',
    Published: 'published',
    Archived: 'archived',
};
exports.PartnerObjectEnum = {
    Partner: 'partner',
};
exports.PartnerList200ResponseObjectEnum = {
    List: 'list',
};
exports.ProductDynamicCreateRequestKindEnum = {
    Dynamic: 'dynamic',
};
exports.ProductFixedCreateRequestKindEnum = {
    Fixed: 'fixed',
};
exports.ProductList200ResponseObjectEnum = {
    List: 'list',
};
exports.ProfileObjectEnum = {
    Profile: 'profile',
};
exports.PromotionObjectEnum = {
    Promotion: 'promotion',
};
exports.PromotionList200ResponseObjectEnum = {
    List: 'list',
};
exports.RewardObjectEnum = {
    Reward: 'reward',
};
/**
 *
 * @export
 * @enum {string}
 */
exports.RewardMode = {
    All: 'all',
    Any: 'any',
    Best: 'best',
};
exports.TaskDefinitionAccountOnboardedObjectEnum = {
    Task: 'task',
};
exports.TaskDefinitionAccountOnboardedTypeEnum = {
    Onboarded: 'onboarded',
};
exports.TaskDefinitionAccountOnboardedCreateRequestTypeEnum = {
    Onboarded: 'onboarded',
};
exports.TaskDefinitionFormObjectEnum = {
    Task: 'task',
};
exports.TaskDefinitionFormTypeEnum = {
    Form: 'form',
};
exports.TaskDefinitionFormCreateRequestTypeEnum = {
    Form: 'form',
};
exports.TaskDefinitionInterviewObjectEnum = {
    Task: 'task',
};
exports.TaskDefinitionInterviewTypeEnum = {
    Interview: 'interview',
};
exports.TaskDefinitionInterviewCreateRequestTypeEnum = {
    Interview: 'interview',
};
/**
 *
 * @export
 * @enum {string}
 */
exports.TaskMode = {
    All: 'all',
    Any: 'any',
};
/**
 *
 * @export
 * @enum {string}
 */
exports.TaskStatusKind = {
    Pending: 'pending',
    Completed: 'completed',
    Error: 'error',
};
exports.TokenObjectEnum = {
    Token: 'token',
};
exports.TokenProfileCreateRequestKindEnum = {
    Contributor: 'contributor',
};
exports.VersionObjectEnum = {
    Version: 'version',
};
/**
 * AdminApi - axios parameter creator
 * @export
 */
const AdminApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary admin contributor list
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminContributorList: async (options = {}) => {
            const localVarPath = `/admin/contributors`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BearerAuth required
            // http bearer authentication required
            await (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary admin offer archive
         * @param {string} offerId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminOfferArchive: async (offerId, options = {}) => {
            // verify required parameter 'offerId' is not null or undefined
            (0, common_1.assertParamExists)('adminOfferArchive', 'offerId', offerId);
            const localVarPath = `/admin/offers/{offerId}/archive`.replace(`{${'offerId'}}`, encodeURIComponent(String(offerId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BearerAuth required
            // http bearer authentication required
            await (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary admin offer create
         * @param {AdminOfferCreatePayload} [adminOfferCreatePayload]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminOfferCreate: async (adminOfferCreatePayload, options = {}) => {
            const localVarPath = `/admin/offers`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BearerAuth required
            // http bearer authentication required
            await (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(adminOfferCreatePayload, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary admin offer list
         * @param {number | null} [limit]
         * @param {OfferStatus} [status]
         * @param {boolean | null} [custom]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminOfferList: async (limit, status, custom, options = {}) => {
            const localVarPath = `/admin/offers`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BearerAuth required
            // http bearer authentication required
            await (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }
            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }
            if (custom !== undefined) {
                localVarQueryParameter['custom'] = custom;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary admin offer publish
         * @param {string} offerId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminOfferPublish: async (offerId, options = {}) => {
            // verify required parameter 'offerId' is not null or undefined
            (0, common_1.assertParamExists)('adminOfferPublish', 'offerId', offerId);
            const localVarPath = `/admin/offers/{offerId}/publish`.replace(`{${'offerId'}}`, encodeURIComponent(String(offerId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BearerAuth required
            // http bearer authentication required
            await (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary admin offer retrieve
         * @param {string} offerId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminOfferRetrieve: async (offerId, options = {}) => {
            // verify required parameter 'offerId' is not null or undefined
            (0, common_1.assertParamExists)('adminOfferRetrieve', 'offerId', offerId);
            const localVarPath = `/admin/offers/{offerId}`.replace(`{${'offerId'}}`, encodeURIComponent(String(offerId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BearerAuth required
            // http bearer authentication required
            await (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary admin partner create
         * @param {PartnerCreatePayload} [partnerCreatePayload]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminPartnerCreate: async (partnerCreatePayload, options = {}) => {
            const localVarPath = `/admin/partners`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BearerAuth required
            // http bearer authentication required
            await (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(partnerCreatePayload, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary admin partner delete
         * @param {string} partnerId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminPartnerDelete: async (partnerId, options = {}) => {
            // verify required parameter 'partnerId' is not null or undefined
            (0, common_1.assertParamExists)('adminPartnerDelete', 'partnerId', partnerId);
            const localVarPath = `/admin/partners/{partnerId}`.replace(`{${'partnerId'}}`, encodeURIComponent(String(partnerId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = {
                method: 'DELETE',
                ...baseOptions,
                ...options,
            };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BearerAuth required
            // http bearer authentication required
            await (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary admin partner list
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminPartnerList: async (options = {}) => {
            const localVarPath = `/admin/partners`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BearerAuth required
            // http bearer authentication required
            await (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary admin partner retrieve
         * @param {string} partnerId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminPartnerRetrieve: async (partnerId, options = {}) => {
            // verify required parameter 'partnerId' is not null or undefined
            (0, common_1.assertParamExists)('adminPartnerRetrieve', 'partnerId', partnerId);
            const localVarPath = `/admin/partners/{partnerId}`.replace(`{${'partnerId'}}`, encodeURIComponent(String(partnerId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BearerAuth required
            // http bearer authentication required
            await (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary admin product create
         * @param {ProductCreateRequest} [productCreateRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminProductCreate: async (productCreateRequest, options = {}) => {
            const localVarPath = `/admin/products`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BearerAuth required
            // http bearer authentication required
            await (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(productCreateRequest, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary admin product delete
         * @param {string} productId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminProductDelete: async (productId, options = {}) => {
            // verify required parameter 'productId' is not null or undefined
            (0, common_1.assertParamExists)('adminProductDelete', 'productId', productId);
            const localVarPath = `/admin/products/{productId}`.replace(`{${'productId'}}`, encodeURIComponent(String(productId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = {
                method: 'DELETE',
                ...baseOptions,
                ...options,
            };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BearerAuth required
            // http bearer authentication required
            await (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary admin product list
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminProductList: async (options = {}) => {
            const localVarPath = `/admin/products`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BearerAuth required
            // http bearer authentication required
            await (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary admin token create
         * @param {TokenProfileCreateRequest} [tokenProfileCreateRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminTokenCreate: async (tokenProfileCreateRequest, options = {}) => {
            const localVarPath = `/admin/tokens`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BearerAuth required
            // http bearer authentication required
            await (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(tokenProfileCreateRequest, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary admin version list
         * @param {string} offer
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminVersionList: async (offer, options = {}) => {
            // verify required parameter 'offer' is not null or undefined
            (0, common_1.assertParamExists)('adminVersionList', 'offer', offer);
            const localVarPath = `/admin/versions`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BearerAuth required
            // http bearer authentication required
            await (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            if (offer !== undefined) {
                localVarQueryParameter['offer'] = offer;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
exports.AdminApiAxiosParamCreator = AdminApiAxiosParamCreator;
/**
 * AdminApi - functional programming interface
 * @export
 */
const AdminApiFp = function (configuration) {
    const localVarAxiosParamCreator = (0, exports.AdminApiAxiosParamCreator)(configuration);
    return {
        /**
         *
         * @summary admin contributor list
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminContributorList(options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminContributorList(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = base_1.operationServerMap['AdminApi.adminContributorList']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary admin offer archive
         * @param {string} offerId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminOfferArchive(offerId, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminOfferArchive(offerId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = base_1.operationServerMap['AdminApi.adminOfferArchive']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary admin offer create
         * @param {AdminOfferCreatePayload} [adminOfferCreatePayload]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminOfferCreate(adminOfferCreatePayload, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminOfferCreate(adminOfferCreatePayload, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = base_1.operationServerMap['AdminApi.adminOfferCreate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary admin offer list
         * @param {number | null} [limit]
         * @param {OfferStatus} [status]
         * @param {boolean | null} [custom]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminOfferList(limit, status, custom, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminOfferList(limit, status, custom, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = base_1.operationServerMap['AdminApi.adminOfferList']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary admin offer publish
         * @param {string} offerId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminOfferPublish(offerId, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminOfferPublish(offerId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = base_1.operationServerMap['AdminApi.adminOfferPublish']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary admin offer retrieve
         * @param {string} offerId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminOfferRetrieve(offerId, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminOfferRetrieve(offerId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = base_1.operationServerMap['AdminApi.adminOfferRetrieve']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary admin partner create
         * @param {PartnerCreatePayload} [partnerCreatePayload]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminPartnerCreate(partnerCreatePayload, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminPartnerCreate(partnerCreatePayload, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = base_1.operationServerMap['AdminApi.adminPartnerCreate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary admin partner delete
         * @param {string} partnerId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminPartnerDelete(partnerId, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminPartnerDelete(partnerId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = base_1.operationServerMap['AdminApi.adminPartnerDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary admin partner list
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminPartnerList(options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminPartnerList(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = base_1.operationServerMap['AdminApi.adminPartnerList']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary admin partner retrieve
         * @param {string} partnerId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminPartnerRetrieve(partnerId, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminPartnerRetrieve(partnerId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = base_1.operationServerMap['AdminApi.adminPartnerRetrieve']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary admin product create
         * @param {ProductCreateRequest} [productCreateRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminProductCreate(productCreateRequest, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminProductCreate(productCreateRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = base_1.operationServerMap['AdminApi.adminProductCreate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary admin product delete
         * @param {string} productId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminProductDelete(productId, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminProductDelete(productId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = base_1.operationServerMap['AdminApi.adminProductDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary admin product list
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminProductList(options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminProductList(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = base_1.operationServerMap['AdminApi.adminProductList']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary admin token create
         * @param {TokenProfileCreateRequest} [tokenProfileCreateRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminTokenCreate(tokenProfileCreateRequest, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminTokenCreate(tokenProfileCreateRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = base_1.operationServerMap['AdminApi.adminTokenCreate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary admin version list
         * @param {string} offer
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminVersionList(offer, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminVersionList(offer, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = base_1.operationServerMap['AdminApi.adminVersionList']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    };
};
exports.AdminApiFp = AdminApiFp;
/**
 * AdminApi - factory interface
 * @export
 */
const AdminApiFactory = function (configuration, basePath, axios) {
    const localVarFp = (0, exports.AdminApiFp)(configuration);
    return {
        /**
         *
         * @summary admin contributor list
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminContributorList(options) {
            return localVarFp
                .adminContributorList(options)
                .then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary admin offer archive
         * @param {AdminApiAdminOfferArchiveRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminOfferArchive(requestParameters, options) {
            return localVarFp
                .adminOfferArchive(requestParameters.offerId, options)
                .then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary admin offer create
         * @param {AdminApiAdminOfferCreateRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminOfferCreate(requestParameters = {}, options) {
            return localVarFp
                .adminOfferCreate(requestParameters.adminOfferCreatePayload, options)
                .then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary admin offer list
         * @param {AdminApiAdminOfferListRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminOfferList(requestParameters = {}, options) {
            return localVarFp
                .adminOfferList(requestParameters.limit, requestParameters.status, requestParameters.custom, options)
                .then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary admin offer publish
         * @param {AdminApiAdminOfferPublishRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminOfferPublish(requestParameters, options) {
            return localVarFp
                .adminOfferPublish(requestParameters.offerId, options)
                .then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary admin offer retrieve
         * @param {AdminApiAdminOfferRetrieveRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminOfferRetrieve(requestParameters, options) {
            return localVarFp
                .adminOfferRetrieve(requestParameters.offerId, options)
                .then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary admin partner create
         * @param {AdminApiAdminPartnerCreateRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminPartnerCreate(requestParameters = {}, options) {
            return localVarFp
                .adminPartnerCreate(requestParameters.partnerCreatePayload, options)
                .then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary admin partner delete
         * @param {AdminApiAdminPartnerDeleteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminPartnerDelete(requestParameters, options) {
            return localVarFp
                .adminPartnerDelete(requestParameters.partnerId, options)
                .then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary admin partner list
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminPartnerList(options) {
            return localVarFp
                .adminPartnerList(options)
                .then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary admin partner retrieve
         * @param {AdminApiAdminPartnerRetrieveRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminPartnerRetrieve(requestParameters, options) {
            return localVarFp
                .adminPartnerRetrieve(requestParameters.partnerId, options)
                .then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary admin product create
         * @param {AdminApiAdminProductCreateRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminProductCreate(requestParameters = {}, options) {
            return localVarFp
                .adminProductCreate(requestParameters.productCreateRequest, options)
                .then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary admin product delete
         * @param {AdminApiAdminProductDeleteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminProductDelete(requestParameters, options) {
            return localVarFp
                .adminProductDelete(requestParameters.productId, options)
                .then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary admin product list
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminProductList(options) {
            return localVarFp
                .adminProductList(options)
                .then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary admin token create
         * @param {AdminApiAdminTokenCreateRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminTokenCreate(requestParameters = {}, options) {
            return localVarFp
                .adminTokenCreate(requestParameters.tokenProfileCreateRequest, options)
                .then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary admin version list
         * @param {AdminApiAdminVersionListRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminVersionList(requestParameters, options) {
            return localVarFp
                .adminVersionList(requestParameters.offer, options)
                .then((request) => request(axios, basePath));
        },
    };
};
exports.AdminApiFactory = AdminApiFactory;
/**
 * AdminApi - object-oriented interface
 * @export
 * @class AdminApi
 * @extends {BaseAPI}
 */
class AdminApi extends base_1.BaseAPI {
    /**
     *
     * @summary admin contributor list
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminApi
     */
    adminContributorList(options) {
        return (0, exports.AdminApiFp)(this.configuration)
            .adminContributorList(options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary admin offer archive
     * @param {AdminApiAdminOfferArchiveRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminApi
     */
    adminOfferArchive(requestParameters, options) {
        return (0, exports.AdminApiFp)(this.configuration)
            .adminOfferArchive(requestParameters.offerId, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary admin offer create
     * @param {AdminApiAdminOfferCreateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminApi
     */
    adminOfferCreate(requestParameters = {}, options) {
        return (0, exports.AdminApiFp)(this.configuration)
            .adminOfferCreate(requestParameters.adminOfferCreatePayload, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary admin offer list
     * @param {AdminApiAdminOfferListRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminApi
     */
    adminOfferList(requestParameters = {}, options) {
        return (0, exports.AdminApiFp)(this.configuration)
            .adminOfferList(requestParameters.limit, requestParameters.status, requestParameters.custom, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary admin offer publish
     * @param {AdminApiAdminOfferPublishRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminApi
     */
    adminOfferPublish(requestParameters, options) {
        return (0, exports.AdminApiFp)(this.configuration)
            .adminOfferPublish(requestParameters.offerId, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary admin offer retrieve
     * @param {AdminApiAdminOfferRetrieveRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminApi
     */
    adminOfferRetrieve(requestParameters, options) {
        return (0, exports.AdminApiFp)(this.configuration)
            .adminOfferRetrieve(requestParameters.offerId, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary admin partner create
     * @param {AdminApiAdminPartnerCreateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminApi
     */
    adminPartnerCreate(requestParameters = {}, options) {
        return (0, exports.AdminApiFp)(this.configuration)
            .adminPartnerCreate(requestParameters.partnerCreatePayload, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary admin partner delete
     * @param {AdminApiAdminPartnerDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminApi
     */
    adminPartnerDelete(requestParameters, options) {
        return (0, exports.AdminApiFp)(this.configuration)
            .adminPartnerDelete(requestParameters.partnerId, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary admin partner list
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminApi
     */
    adminPartnerList(options) {
        return (0, exports.AdminApiFp)(this.configuration)
            .adminPartnerList(options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary admin partner retrieve
     * @param {AdminApiAdminPartnerRetrieveRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminApi
     */
    adminPartnerRetrieve(requestParameters, options) {
        return (0, exports.AdminApiFp)(this.configuration)
            .adminPartnerRetrieve(requestParameters.partnerId, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary admin product create
     * @param {AdminApiAdminProductCreateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminApi
     */
    adminProductCreate(requestParameters = {}, options) {
        return (0, exports.AdminApiFp)(this.configuration)
            .adminProductCreate(requestParameters.productCreateRequest, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary admin product delete
     * @param {AdminApiAdminProductDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminApi
     */
    adminProductDelete(requestParameters, options) {
        return (0, exports.AdminApiFp)(this.configuration)
            .adminProductDelete(requestParameters.productId, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary admin product list
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminApi
     */
    adminProductList(options) {
        return (0, exports.AdminApiFp)(this.configuration)
            .adminProductList(options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary admin token create
     * @param {AdminApiAdminTokenCreateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminApi
     */
    adminTokenCreate(requestParameters = {}, options) {
        return (0, exports.AdminApiFp)(this.configuration)
            .adminTokenCreate(requestParameters.tokenProfileCreateRequest, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary admin version list
     * @param {AdminApiAdminVersionListRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminApi
     */
    adminVersionList(requestParameters, options) {
        return (0, exports.AdminApiFp)(this.configuration)
            .adminVersionList(requestParameters.offer, options)
            .then((request) => request(this.axios, this.basePath));
    }
}
exports.AdminApi = AdminApi;
/**
 * DefaultApi - axios parameter creator
 * @export
 */
const DefaultApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary eligibility create
         * @param {EligibilityCreateRequest} [eligibilityCreateRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        eligibilityCreate: async (eligibilityCreateRequest, options = {}) => {
            const localVarPath = `/eligibility`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BearerAuth required
            // http bearer authentication required
            await (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(eligibilityCreateRequest, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary offer list
         * @param {number | null} [limit]
         * @param {OfferStatus} [status]
         * @param {boolean | null} [custom]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        offerList: async (limit, status, custom, options = {}) => {
            const localVarPath = `/offers`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BearerAuth required
            // http bearer authentication required
            await (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }
            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }
            if (custom !== undefined) {
                localVarQueryParameter['custom'] = custom;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary offer retrieve
         * @param {string} offerId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        offerRetrieve: async (offerId, options = {}) => {
            // verify required parameter 'offerId' is not null or undefined
            (0, common_1.assertParamExists)('offerRetrieve', 'offerId', offerId);
            const localVarPath = `/offers/{offerId}`.replace(`{${'offerId'}}`, encodeURIComponent(String(offerId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BearerAuth required
            // http bearer authentication required
            await (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary partner list
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        partnerList: async (options = {}) => {
            const localVarPath = `/partners`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BearerAuth required
            // http bearer authentication required
            await (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary partner retrieve
         * @param {string} partnerId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        partnerRetrieve: async (partnerId, options = {}) => {
            // verify required parameter 'partnerId' is not null or undefined
            (0, common_1.assertParamExists)('partnerRetrieve', 'partnerId', partnerId);
            const localVarPath = `/partners/{partnerId}`.replace(`{${'partnerId'}}`, encodeURIComponent(String(partnerId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BearerAuth required
            // http bearer authentication required
            await (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary product list
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        productList: async (options = {}) => {
            const localVarPath = `/products`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BearerAuth required
            // http bearer authentication required
            await (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary profile create
         * @param {object} [body]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        profileCreate: async (body, options = {}) => {
            const localVarPath = `/profile`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BearerAuth required
            // http bearer authentication required
            await (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(body, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary profile retrieve
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        profileRetrieve: async (options = {}) => {
            const localVarPath = `/profile`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BearerAuth required
            // http bearer authentication required
            await (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary promotion list
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        promotionList: async (options = {}) => {
            const localVarPath = `/promotions`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BearerAuth required
            // http bearer authentication required
            await (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
exports.DefaultApiAxiosParamCreator = DefaultApiAxiosParamCreator;
/**
 * DefaultApi - functional programming interface
 * @export
 */
const DefaultApiFp = function (configuration) {
    const localVarAxiosParamCreator = (0, exports.DefaultApiAxiosParamCreator)(configuration);
    return {
        /**
         *
         * @summary eligibility create
         * @param {EligibilityCreateRequest} [eligibilityCreateRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async eligibilityCreate(eligibilityCreateRequest, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.eligibilityCreate(eligibilityCreateRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = base_1.operationServerMap['DefaultApi.eligibilityCreate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary offer list
         * @param {number | null} [limit]
         * @param {OfferStatus} [status]
         * @param {boolean | null} [custom]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async offerList(limit, status, custom, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.offerList(limit, status, custom, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = base_1.operationServerMap['DefaultApi.offerList']?.[localVarOperationServerIndex]
                ?.url;
            return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary offer retrieve
         * @param {string} offerId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async offerRetrieve(offerId, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.offerRetrieve(offerId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = base_1.operationServerMap['DefaultApi.offerRetrieve']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary partner list
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async partnerList(options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.partnerList(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = base_1.operationServerMap['DefaultApi.partnerList']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary partner retrieve
         * @param {string} partnerId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async partnerRetrieve(partnerId, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.partnerRetrieve(partnerId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = base_1.operationServerMap['DefaultApi.partnerRetrieve']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary product list
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async productList(options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.productList(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = base_1.operationServerMap['DefaultApi.productList']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary profile create
         * @param {object} [body]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async profileCreate(body, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.profileCreate(body, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = base_1.operationServerMap['DefaultApi.profileCreate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary profile retrieve
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async profileRetrieve(options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.profileRetrieve(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = base_1.operationServerMap['DefaultApi.profileRetrieve']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary promotion list
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async promotionList(options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.promotionList(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = base_1.operationServerMap['DefaultApi.promotionList']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    };
};
exports.DefaultApiFp = DefaultApiFp;
/**
 * DefaultApi - factory interface
 * @export
 */
const DefaultApiFactory = function (configuration, basePath, axios) {
    const localVarFp = (0, exports.DefaultApiFp)(configuration);
    return {
        /**
         *
         * @summary eligibility create
         * @param {DefaultApiEligibilityCreateRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        eligibilityCreate(requestParameters = {}, options) {
            return localVarFp
                .eligibilityCreate(requestParameters.eligibilityCreateRequest, options)
                .then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary offer list
         * @param {DefaultApiOfferListRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        offerList(requestParameters = {}, options) {
            return localVarFp
                .offerList(requestParameters.limit, requestParameters.status, requestParameters.custom, options)
                .then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary offer retrieve
         * @param {DefaultApiOfferRetrieveRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        offerRetrieve(requestParameters, options) {
            return localVarFp
                .offerRetrieve(requestParameters.offerId, options)
                .then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary partner list
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        partnerList(options) {
            return localVarFp
                .partnerList(options)
                .then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary partner retrieve
         * @param {DefaultApiPartnerRetrieveRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        partnerRetrieve(requestParameters, options) {
            return localVarFp
                .partnerRetrieve(requestParameters.partnerId, options)
                .then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary product list
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        productList(options) {
            return localVarFp
                .productList(options)
                .then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary profile create
         * @param {DefaultApiProfileCreateRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        profileCreate(requestParameters = {}, options) {
            return localVarFp
                .profileCreate(requestParameters.body, options)
                .then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary profile retrieve
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        profileRetrieve(options) {
            return localVarFp
                .profileRetrieve(options)
                .then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary promotion list
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        promotionList(options) {
            return localVarFp
                .promotionList(options)
                .then((request) => request(axios, basePath));
        },
    };
};
exports.DefaultApiFactory = DefaultApiFactory;
/**
 * DefaultApi - object-oriented interface
 * @export
 * @class DefaultApi
 * @extends {BaseAPI}
 */
class DefaultApi extends base_1.BaseAPI {
    /**
     *
     * @summary eligibility create
     * @param {DefaultApiEligibilityCreateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    eligibilityCreate(requestParameters = {}, options) {
        return (0, exports.DefaultApiFp)(this.configuration)
            .eligibilityCreate(requestParameters.eligibilityCreateRequest, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary offer list
     * @param {DefaultApiOfferListRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    offerList(requestParameters = {}, options) {
        return (0, exports.DefaultApiFp)(this.configuration)
            .offerList(requestParameters.limit, requestParameters.status, requestParameters.custom, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary offer retrieve
     * @param {DefaultApiOfferRetrieveRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    offerRetrieve(requestParameters, options) {
        return (0, exports.DefaultApiFp)(this.configuration)
            .offerRetrieve(requestParameters.offerId, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary partner list
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    partnerList(options) {
        return (0, exports.DefaultApiFp)(this.configuration)
            .partnerList(options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary partner retrieve
     * @param {DefaultApiPartnerRetrieveRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    partnerRetrieve(requestParameters, options) {
        return (0, exports.DefaultApiFp)(this.configuration)
            .partnerRetrieve(requestParameters.partnerId, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary product list
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    productList(options) {
        return (0, exports.DefaultApiFp)(this.configuration)
            .productList(options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary profile create
     * @param {DefaultApiProfileCreateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    profileCreate(requestParameters = {}, options) {
        return (0, exports.DefaultApiFp)(this.configuration)
            .profileCreate(requestParameters.body, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary profile retrieve
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    profileRetrieve(options) {
        return (0, exports.DefaultApiFp)(this.configuration)
            .profileRetrieve(options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary promotion list
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    promotionList(options) {
        return (0, exports.DefaultApiFp)(this.configuration)
            .promotionList(options)
            .then((request) => request(this.axios, this.basePath));
    }
}
exports.DefaultApi = DefaultApi;
/**
 * TokenApi - axios parameter creator
 * @export
 */
const TokenApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary token profile create
         * @param {TokenAcceptRequest} [tokenAcceptRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        tokenProfileCreate: async (tokenAcceptRequest, options = {}) => {
            const localVarPath = `/profile/token`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BearerAuth required
            // http bearer authentication required
            await (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {
                ...localVarHeaderParameter,
                ...headersFromBaseOptions,
                ...options.headers,
            };
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(tokenAcceptRequest, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
exports.TokenApiAxiosParamCreator = TokenApiAxiosParamCreator;
/**
 * TokenApi - functional programming interface
 * @export
 */
const TokenApiFp = function (configuration) {
    const localVarAxiosParamCreator = (0, exports.TokenApiAxiosParamCreator)(configuration);
    return {
        /**
         *
         * @summary token profile create
         * @param {TokenAcceptRequest} [tokenAcceptRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async tokenProfileCreate(tokenAcceptRequest, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.tokenProfileCreate(tokenAcceptRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = base_1.operationServerMap['TokenApi.tokenProfileCreate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    };
};
exports.TokenApiFp = TokenApiFp;
/**
 * TokenApi - factory interface
 * @export
 */
const TokenApiFactory = function (configuration, basePath, axios) {
    const localVarFp = (0, exports.TokenApiFp)(configuration);
    return {
        /**
         *
         * @summary token profile create
         * @param {TokenApiTokenProfileCreateRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        tokenProfileCreate(requestParameters = {}, options) {
            return localVarFp
                .tokenProfileCreate(requestParameters.tokenAcceptRequest, options)
                .then((request) => request(axios, basePath));
        },
    };
};
exports.TokenApiFactory = TokenApiFactory;
/**
 * TokenApi - object-oriented interface
 * @export
 * @class TokenApi
 * @extends {BaseAPI}
 */
class TokenApi extends base_1.BaseAPI {
    /**
     *
     * @summary token profile create
     * @param {TokenApiTokenProfileCreateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TokenApi
     */
    tokenProfileCreate(requestParameters = {}, options) {
        return (0, exports.TokenApiFp)(this.configuration)
            .tokenProfileCreate(requestParameters.tokenAcceptRequest, options)
            .then((request) => request(this.axios, this.basePath));
    }
}
exports.TokenApi = TokenApi;
//# sourceMappingURL=api.js.map